import { IStore } from '../../../common/type';

const selectModuleState = (state: IStore) => state.customer;

export const selectCustomers = (state: IStore) => selectModuleState(state).customers;



// WEBPACK FOOTER //
// ./src/modules/customers/parts/customer-selector.ts